import { type PropsWithChildren, createContext, useContext, useState } from 'react'

import { useEntitiesContext } from 'entities/EntitiesExport'
import { TagsStore } from 'pages/settings/pages/tags/store/TagsStore'

const TagsContext = createContext<TagsStore | null>(null)

export const useTagsContext = () => {
  const context = useContext(TagsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with TagsProvider')

  return context
}

export const TagsProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new TagsStore(entities))

  return <TagsContext.Provider value={store}>{children}</TagsContext.Provider>
}
